export default __webpack_public_path__ + "static/media/path3.f1a17c98.svg";